import { ProFormUploadButton } from '@ant-design/pro-components'
import type { UploadFile } from 'antd'
import type React from 'react'
import { EditableShell } from '../components/EditableShell'
import { useFieldContext } from '../createAppFormHook'
import { useEditableFieldMode } from '../hooks/useEditableFieldMode'
import { useMergedFieldProps } from '../utils/mergeFieldProps'

export type UploadButtonFieldProps = React.ComponentProps<typeof ProFormUploadButton>

export function UploadButtonField(props: UploadButtonFieldProps) {
  const fieldCtx = useFieldContext<UploadFile[] | undefined>()
  const { formItemProps, fieldProps, proFieldProps, className, ...rest } = props

  const editable = useEditableFieldMode<UploadFile[] | undefined>()

  const merged = useMergedFieldProps({
    fieldCtx,
    editable,
    props,
    fieldDefaults: {
      fieldProps: {
        // Upload expects fileList instead of value
        value: undefined as unknown as never,
        fileList: Array.isArray(fieldCtx.state.value) ? fieldCtx.state.value : [],
        onChange: (info: { fileList: UploadFile[] }) => {
          fieldCtx.handleChange(info.fileList)
        },
      },
    },
  })

  return (
    <EditableShell
      mode={editable.mode}
      enterEdit={editable.enterEdit}
      exitRead={editable.exitRead}
      className={className}
    >
      <ProFormUploadButton
        {...rest}
        proFieldProps={merged.proFieldProps}
        formItemProps={merged.formItemProps}
        fieldProps={merged.fieldProps}
      />
    </EditableShell>
  )
}
